import { Outlet } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";
import { useState, useEffect } from "react";

export default function AcademyAdminLayout() {
  const [isMobile, setIsMobile] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  // التحقق من حجم الشاشة
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
      if (window.innerWidth < 768) {
        setSidebarCollapsed(true);
      }
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  // تبديل حالة الشريط الجانبي
  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  // تنسيقات CSS بسيطة
  const styles = {
    container: {
      minHeight: "100vh",
      backgroundColor: "#f8f9fa",
      direction: "rtl"
    },
    contentWrapper: {
      display: "flex",
      minHeight: "calc(100vh - 70px)",
      marginTop: "70px",
      transition: "all 0.3s ease"
    },
    mainContent: {
      flex: 1,
      padding: "25px",
      backgroundColor: "#f8f9fa",
      minHeight: "calc(100vh - 70px)",
      overflowX: "hidden",
      transition: "padding 0.3s ease"
    },
    overlay: {
      position: "fixed",
      top: "70px",
      right: "0",
      bottom: "0",
      left: "0",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: "999",
      display: isMobile && !sidebarCollapsed ? "block" : "none"
    },
    toggleButton: {
      position: "fixed",
      bottom: "20px",
      right: "20px",
      width: "50px",
      height: "50px",
      borderRadius: "50%",
      backgroundColor: "#4b6cb7",
      color: "white",
      border: "none",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      zIndex: "1000",
      boxShadow: "0 4px 12px rgba(75, 108, 183, 0.3)",
      transition: "all 0.3s ease",
      fontSize: "20px"
    }
  };

  return (
    <div style={styles.container}>
      {/* الرأس */}
      <Header />
      
      {/* طبقة التعتيم للهاتف */}
      <div 
        style={styles.overlay}
        onClick={() => setSidebarCollapsed(true)}
      />
      
      {/* زر تبديل الشريط الجانبي للهاتف */}
      {isMobile && (
        <button 
          style={styles.toggleButton}
          onClick={toggleSidebar}
          onMouseEnter={(e) => e.currentTarget.style.transform = "scale(1.1)"}
          onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}
        >
          {sidebarCollapsed ? "☰" : "✕"}
        </button>
      )}
      
      {/* المحتوى الرئيسي */}
      <div style={styles.contentWrapper}>
        {/* الشريط الجانبي */}
        <Sidebar />
        
        {/* المحتوى */}
        <main style={{
          ...styles.mainContent,
          marginRight: isMobile ? "0" : (sidebarCollapsed ? "70px" : "280px"),
          padding: isMobile ? "15px" : "25px"
        }}>
          <Outlet />
        </main>
      </div>

      {/* إضافة CSS للأنيميشن */}
      <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
        
        .main-content {
          animation: fadeIn 0.3s ease-out;
        }
        
        @media (max-width: 768px) {
          .main-content {
            margin-right: 0 !important;
          }
        }
        
        @media (max-width: 480px) {
          .main-content {
            padding: 10px !important;
          }
        }
      `}</style>
    </div>
  );
}